module.exports = __webpack_public_path__ + "images/category_lp/common/icon-babble-right_153cc0daad824fce57ca6b59944e13af.png";